<template>
  <!-- Displays list of Sub-Itineraries within an Itinerary -->
  <div id="sub-itinerary-list-container">
    <div id="itinerary-description">
      <div
        id="itinerary-language-selection"
        v-if="itineraryDescriptionLanguages.length > 1"
      >
        <label>Read in </label>
        <select v-model="itineraryDescriptionLanguage">
          <option
            v-for="language in itineraryDescriptionLanguages"
            :key="language"
          >
            {{ language }}
          </option>
        </select>
      </div>
      <DescriptionComponent
        v-if="itineraryDescriptionLanguage.length > 0"
        :language="itineraryDescriptionLanguage"
        :texts="current.itineraryDescription[0].details"
        :characters="descriptionChars"
        :glossary="current.glossary"
      >
      </DescriptionComponent>
    </div>

    <div id="sub-itinerary-label">
      <!-- Show number of Sub-Itineraries -->
      {{ nextOrdered.length }} Sub-Itineraries
    </div>
    <div
      class="sub-itinerary-wrapper"
      v-for="entry in nextOrdered"
      :key="entry.thisId"
    >
      <div
        class="sub-itinerary-image"
        :style="{ backgroundImage: 'url(' + entry.subItineraryImage + ')' }"
      ></div>
      <div class="sub-itinerary-info">
        <div class="sub-itinerary-link">
          <router-link
            :to="{
              name: 'itineraries',
              params: {
                country: $route.params.country,
                itinerary: `i-${current.itineraryId}`,
                subItinerary: `si-${entry.subItineraryId}`,
              },
            }"
          >
            {{ entry.name }}
            <span v-if="returnValueInLanguage('en', entry.nameArray).duration">
              [{{ returnValueInLanguage("en", entry.nameArray).duration }}]
            </span>
          </router-link>
        </div>
        <div
          class="sub-itinerary-description"
          v-if="entry.displayDescription"
          v-html="truncate(400, entry.description)"
        ></div>
      </div>
    </div>

    <div
      id="itinerary-local-team-container"
      v-if="
        current.itineraryDescription &&
        current.itineraryDescription[0].details[0].localTeam &&
        current.itineraryDescription[0].details[0].localTeam.length > 0
      "
    >
      <div
        id="itinerary-local-team-toggle"
        @click="showLocalTeam = !showLocalTeam"
      >
        <span v-if="!showLocalTeam">&#62;&#62; Show </span>
        <span v-else>&#60;&#60; Hide </span>
        Local Team
      </div>
      <div
        id="itinerary-local-team"
        v-if="showLocalTeam"
        v-html="current.itineraryDescription[0].details[0].localTeam"
      ></div>
    </div>

    <BooksTours :books="current.mwnfTravelBook" :tours="current.mwnfTour">
    </BooksTours>
  </div>
</template>

<script>
import DescriptionComponent from "./DescriptionComponent.vue";
import BooksTours from "./BooksTours.vue";
import language from "../mixins/language.js";
import truncate from "../mixins/truncate.js";
export default {
  name: "SubItineraryList",
  components: {
    DescriptionComponent: DescriptionComponent,
    BooksTours: BooksTours,
  },
  mixins: [language, truncate],
  props: ["current", "next"],
  watch: {
    current() {
      this.getLanguages(
        this.current.itineraryDescription[0].details,
        "itineraryDescriptionLanguage",
        "itineraryDescriptionLanguages"
      );
    },
    next() {
      this.setDescriptions(this.next);
    },
  },
  computed: {
    // Order Sub-Itineraries by...order
    nextOrdered: function () {
      return this.subItineraries.slice(0).sort(function (a, b) {
        let orderA = a.subItineraryOrder;
        let orderB = b.subItineraryOrder;
        return orderA < orderB ? -1 : orderA > orderB ? 1 : 0;
      });
    },
  },
  data() {
    return {
      itineraryDescriptionLanguage: "",
      itineraryDescriptionLanguages: [],
      descriptionChars: 575,
      subItineraries: [],
      showLocalTeam: false,
    };
  },
  methods: {
    setDescriptions: function (next) {
      this.subItineraries = this.next;
      for (let i = 0; i < next.length; i++) {
        if (
          next[i].subItineraryDescription &&
          next[i].subItineraryDescription.length > 0
        ) {
          if (
            this.returnValueInLanguage(
              "en",
              next[i].subItineraryDescription[0].details
            )
          ) {
            // Set description to English text
            this.subItineraries[i].description = this.returnValueInLanguage(
              "en",
              next[i].subItineraryDescription[0].details
            ).description;
            // Else, use first available language other than English
          } else {
            // Set to [0] of details as it would be the first
            this.subItineraries[i].description =
              next[i].subItineraryDescription[0].details[0].description;
          }
          // Set display to true for description
          this.subItineraries[i].displayDescription = true;
          // Else there is no description
        } else {
          this.subItineraries[i].displayDescription = false;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
#sub-itinerary-list-container {
  width: 100%;
}

#itinerary-language-selection {
  margin-bottom: 10px;
}
#itinerary-language-selection * {
  @include texts;
  @include font-size-6;
}

#itinerary-description {
  margin-bottom: 20px;
}
#itinerary-description span {
  @include texts;
  @include font-size-6;
}
.description-toggle {
  cursor: pointer;
}
.description-toggle .read {
  font-weight: bold;
  text-decoration: underline;
}

#sub-itinerary-label {
  @include headings;
  @include font-size-3;
  margin-top: 30px;
  margin-bottom: 20px;
}
.sub-itinerary-wrapper {
  display: flex;
  height: 200px;
  width: 100%;
  box-shadow: 0px 2px 8px $light-grey;
  margin-bottom: 20px;
}
.sub-itinerary-image {
  height: 200px;
  width: 300px;
  background-color: $dark-green;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.sub-itinerary-info {
  width: 100%;
  padding: 20px 30px;
}

.sub-itinerary-link a {
  @include headings;
  @include font-size-5;
  color: $dark-green;
}
.sub-itinerary-description {
  margin-top: 20px;
}
.sub-itinerary-description,
.sub-itinerary-description :deep(*) {
  @include texts;
  @include font-size-6;
}
.sub-itinerary-description :deep(br) {
  content: " ";
}
.sub-itinerary-description :deep(br:after) {
  content: " ";
}

#itinerary-local-team-toggle,
#itinerary-local-team-toggle span,
#itinerary-local-team,
#itinerary-local-team :deep(*) {
  @include texts;
}
#itinerary-local-team-toggle,
#itinerary-local-team-toggle span {
  @include font-size-5;
  font-weight: bold;
  text-decoration: underline;
  color: $dark-green;
}
#itinerary-local-team-toggle {
  margin-bottom: 20px;
}
#itinerary-local-team-toggle:hover {
  cursor: pointer;
}
#itinerary-local-team,
#itinerary-local-team :deep(*) {
  @include font-size-6;
}

@media only screen and (max-width: 899px) {
  .sub-itinerary-wrapper {
    height: 300px;
    width: 100%;
  }
  .sub-itinerary-image {
    height: 300px;
    width: 400px;
  }
}

@media only screen and (max-width: 699px) {
  .sub-itinerary-wrapper {
    flex-direction: column;
    height: auto;
    width: 100%;
  }
  .sub-itinerary-image {
    height: 200px;
    width: 100%;
  }
}

@media only screen and (max-width: 499px) {
  #sub-itinerary-label {
    @include font-size-4;
  }
  .sub-itinerary-info {
    padding: 15px;
  }
}
</style>
